<template>
	<div :class="wrapperCssClasses">
		<input
			:class="inputClassObject"
			:id="id"
			:name="name"
			type="checkbox"
			:value="value"
			@change="$emit('MCheckboxChecked', $event)"
			:checked="checked"
			:disabled="disabled"
		/>
		<label :for="id" :title="title"
			><span class="item-description">{{ label }}</span
			><slot name="extraLabel"></slot
			><span v-if="includeCheckMark" class="icon-checkmark"></span
		></label>
		<m-errors v-if="errors_" :errors="errors_" />
	</div>
</template>

<script>
import MErrors from './MErrors';
export default {
	name: 'MCheckbox',
	components: {
		MErrors
	},
	props: {
		wrapperCssClasses: String,
		label: String,
		title: String,
		name: String,
		id: String,
		value: String,
		checked: Boolean,
		includeCheckMark: {
			type: Boolean,
			default: true
		},
		disabled: {
			type: Boolean,
			default: false
		},
		inputClass: {
			type: String,
			default: 'mcheckbox'
		},
		errors: {
			type: Object,
			default() {
				return {}
			}
		}
	},
	computed: {
		errors_() {
			return this.errors.getOwnPropertyDescriptor(this.name)
				? this.errors[this.name]
				: false;
		},

		inputClassObject() {
			return this.errors.length > 0
				? ['warning', this.inputClass]
				: [this.inputClass];
		}
	}
}
</script>

<style scoped></style>
